import { useNavigate } from "react-router-dom";
import { useUserApi } from "../hooks/useUserApi";
import { useTranslation } from "react-i18next";

const DarkWarning = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { updateUser } = useUserApi();
  const handleNavigation = async () => {
    await updateUser({ dark_mode_warning_shown: true });
    navigate("/questionnaire");
  };

  return (
    <div className="min-h-dvh bg-black85 flex flex-col p-4 sm:p-6 md:p-8">
      {/* Warning Icon Section */}
      <div className="pt-4 sm:pt-8 md:pt-12 pb-2 sm:pb-3 md:pb-4 flex justify-center">
        <img
          src="/icons/warning.svg"
          alt="warning"
          loading="lazy"
          className="w-40 h-40 sm:w-48 sm:h-48 md:w-56 md:h-56 lg:w-64 lg:h-64"
        />
      </div>

      {/* Text Content Section - Flexible with better spacing */}
      <div className="px-1 sm:px-2 md:px-2 lg:px-4 xl:px-6">
        <div className="text-white text-center space-y-4 sm:space-y-5 md:space-y-6 lg:space-y-8 max-w-2xl mx-auto">
          <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-18 leading-relaxed sm:leading-relaxed md:leading-loose font-medium">
            {t("darkwallHeading1")}
          </p>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-18 leading-relaxed sm:leading-relaxed md:leading-loose font-medium">
            {t("darkwallHeading2")}
          </p>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-18 leading-relaxed sm:leading-relaxed md:leading-loose font-medium">
            {t("darkwallHeading3")}
          </p>
        </div>
      </div>

      {/* Buttons Section - Fixed at bottom with better spacing */}
      <div className="flex-1 flex flex-col justify-end gap-3 sm:gap-4 md:gap-5 pb-4 sm:pb-6 md:pb-8">
        <button
          onClick={() => navigate(-1)}
          className="bg-neutral-grey hover:bg-neutral-grey/80 text-white rounded-xl font-bold px-4 sm:px-6 md:px-8 py-3 sm:py-4 text-sm sm:text-base md:text-lg lg:text-xl uppercase transition-all duration-300 shadow-sangati mx-auto w-full max-w-xs sm:max-w-sm md:max-w-md focus:outline-none focus:ring-2 focus:ring-white/20"
        >
          {t("back")}
        </button>
        <button
          onClick={handleNavigation}
          className="bg-sangati-green hover:bg-sangati-green/80 text-white rounded-xl font-bold px-4 sm:px-6 md:px-8 py-3 sm:py-4 text-sm sm:text-base md:text-lg lg:text-xl uppercase transition-all duration-300 shadow-sangati mx-auto w-full max-w-xs sm:max-w-sm md:max-w-md focus:outline-none focus:ring-2 focus:ring-white/20"
        >
          {t("continue")}
        </button>
      </div>
    </div>
  );
};

export default DarkWarning;
